import React from 'react';
import PropTypes from 'prop-types';
import { useFeatureFlag } from 'common/hooks';
import { StatusBadge } from 'src/common/badges';
import { AUTHORIZATION_STATUSES } from 'src/common/Status/authorizationConstants';

const badgeProps = {
  [AUTHORIZATION_STATUSES.open]: {
    className: 'bg-dark-border-blue text-text-blue',
    label: 'Open',
  },
  [AUTHORIZATION_STATUSES.accepted]: {
    className: 'bg-dark-green text-white',
    label: 'Accepted',
  },
  [AUTHORIZATION_STATUSES.rejected]: {
    className: 'bg-red text-white',
    label: 'Rejected',
  },
  [AUTHORIZATION_STATUSES.inReview]: {
    className: 'bg-orange text-white',
    label: 'In Review',
  },
  [AUTHORIZATION_STATUSES.void]: {
    className: 'bg-action-blue text-white',
    label: 'Voided',
  },
};

const validStatuses = Object.keys(badgeProps);

const ServiceAuthorizationStatusIndicator = ({
  status,
  autoApproved,
  isUrgent,
  isUpdateRequest,
}) => {
  const markAsUrgentEnabled = useFeatureFlag('pays-auth-mark-as-urgent');

  if (!validStatuses.includes(status)) return '';
  const { className, label } = badgeProps[status];

  let displayLabel = label;
  if (autoApproved && status === AUTHORIZATION_STATUSES.accepted) {
    displayLabel = `Auto ${label}`;
  } else if (isUpdateRequest && status === AUTHORIZATION_STATUSES.accepted) {
    displayLabel = 'Updated';
  }

  const shouldShowUrgent = markAsUrgentEnabled && isUrgent &&
    (status === AUTHORIZATION_STATUSES.open || status === AUTHORIZATION_STATUSES.inReview);

  if (shouldShowUrgent) {
    return (
      <div className="inline-flex items-center flex-nowrap gap-2 whitespace-nowrap">
        <StatusBadge className={className} label={displayLabel} />
        <span className="text-red font-bold text-xs flex-shrink-0">Urgent</span>
      </div>
    );
  }

  return <StatusBadge className={className} label={displayLabel} />;
};

ServiceAuthorizationStatusIndicator.propTypes = {
  status: PropTypes.oneOf(validStatuses).isRequired,
  autoApproved: PropTypes.bool,
  isUrgent: PropTypes.bool,
  isUpdateRequest: PropTypes.bool,
};

ServiceAuthorizationStatusIndicator.defaultProps = {
  autoApproved: false,
  isUrgent: false,
  isUpdateRequest: false,
};

export default ServiceAuthorizationStatusIndicator;
